import { formatMoney } from 'accounting'

import { Search } from '@domain-group/suit-theme'

import { CustomItemModel } from '@models/types'

import searchFn from '@functions/search'

type GroupItem = {
  key: number,
  secondaryText?: string,
  text: string,
}

type Group = {
  [key: number]: {
    items: GroupItem[],
    key: number,
    title: string,
  },
}

const mapResults = (results: CustomItemModel[]) => {
  if (!results.length){
    return {}
  }

  const groups = results.reduce((acc, result: CustomItemModel) => {
    const {
      custom_item_group,
      custom_item_group_id,
      id,
      price,
      title,
    } = result

    if (!acc[custom_item_group_id]){
      acc[custom_item_group_id] = {
        items: [],
        key: custom_item_group_id,
        title: custom_item_group?.title || `Group #${custom_item_group_id}`,
      }
    }

    acc[custom_item_group_id].items.push({
      ...result,
      key: id,
      secondaryText: formatMoney(price),
      text: title,
    })

    return acc
  }, {} as Group)

  const mapped = {
    groups: Object.values(groups),
  }

  return mapped
}
interface CustomItemSearchProps {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (item: CustomItemModel) => void,
  },
  value: string,
}

const CustomItemSearch = (props: CustomItemSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2322
        mapResults,
      }}
      debounceInterval={300}
      endpoint="custom_items.json"
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: true,
        showOnFocus: true,
        filterItems: false,
      }}
      // @ts-expect-error TS2322
      requestOptions={{ include_custom_item_custom_item_group: true }}
      value={value}
    />
  )
}

export default CustomItemSearch
